export function getFluidImage(image) {
  if (!image) return image;
  if (image.srcSet) return image;
  // TODO reconstruct the srcSet from src.
  const srcSet = '';
  return { srcSet, ...image };
}

export function getFixedImage(image) {
  if (!image) return image;
  if (image.srcSet) return image;
  // TODO reconstruct the srcSet from src.
  const srcSet = '';
  return { srcSet, ...image };
}
